import React, { useState } from 'react';

import { Option, Wrapper } from './wrapper';

interface SegmentedControlOptionProps {
  id?: string;
  label: string;
  title?: string;
  onClick: () => void;
}

interface SegmentedControlProps {
  label: string;
  options: SegmentedControlOptionProps[];
  defaultActiveIndex?: number;
}

const SegmentedControl = ({ label, options, defaultActiveIndex = 0 }: SegmentedControlProps) => {
  const [pressedIndex, setPressedIndex] = useState<number | null>(defaultActiveIndex);

  return (
    <Wrapper aria-label={label}>
      {options.map((option, index) => {
        // Handle aria-pressed state and defaults first option to pressed
        const pressed = pressedIndex === index;

        const _onClick = () => {
          setPressedIndex(index);
          option.onClick();
        };

        return (
          <Option
            key={option.label}
            type="button"
            onClick={_onClick}
            title={option.title || option.label}
            aria-pressed={pressed}
          >
            {option.label}
          </Option>
        );
      })}
    </Wrapper>
  );
};

export default SegmentedControl;
